module.exports = __webpack_public_path__ + "ba557f7ac7e3b4c06e0ac12f5b5152.png";